import AccountSummaryPage from "components/pages/AccountSummaryPage";

/**
 * @name CaptureTransfersAccountSummary
 * @returns {React.Component}
 * @description The capture component for the account summary page in the transfers group
 * This capture is used in the following capture groups:
 * "Transfers" (abi22), "Transfers - Recurring" (abi22), "Transfers" (mabi23).
 */
export default function CaptureTransfersAccountSummary(props) {
    return <AccountSummaryPage />
}